<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Montaże</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/montages/list">Montaże</router-link>
        </li>
        <li class="active">
          <strong>Edycja</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight montagesb">
    <div class="row">
      <div class="col-lg-12"></div>
    </div>
    <button @click="changeStatus" class="btn btn-primary mb-25">
      Zmiana statusu
    </button>
    <button
      v-if="canDuplicateMontage"
      :disabled="isDuplicating"
      @click="askDuplicateMontage(montagePk)"
      class="btn btn-primary mb-25 m-l-sm"
    >
      <font-awesome-icon icon="copy" class="table-helper-item" />
      <span>{{ isDuplicating ? "Duplikowanie..." : "Duplikuj" }}</span>
    </button>
    <div class="row">
      <div class="col-lg-8">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Edycja montażu</h5>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-horizontal">
                  <div class="ibox-content">
                    <div class="form-group">
                      <label class="control-label col-sm-2">Nazwa</label>
                      <div class="col-sm-10">
                        <input
                          v-model="montageObj.name"
                          type="text"
                          class="form-control inputClass"
                          placeholder="Nazwa"
                          required="required"
                        />
                        <div
                          v-if="errorsAdminData?.data?.name"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.name[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">Nakład netto</label>
                      <div class="col-sm-10">
                        <input
                          v-model="montageObj.quantity_net"
                          type="number"
                          class="form-control inputClass"
                          placeholder="Nakład netto"
                          required="required"
                        />
                        <div
                          v-if="errorsAdminData?.data?.quantity_net"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.quantity_net[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">Naddatek</label>
                      <div class="col-sm-10">
                        <input
                          v-model="montageObj.quantity_surplus"
                          type="number"
                          class="form-control inputClass"
                          placeholder="Naddatek"
                          required="required"
                        />
                        <div
                          v-if="errorsAdminData?.data?.quantity_surplus"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.quantity_surplus[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">
                        Nakład brutto
                      </label>
                      <div class="col-sm-10">
                        <input
                          :value="
                            Number(montageObj.quantity_net || 0) +
                            Number(montageObj.quantity_surplus || 0)
                          "
                          type="number"
                          class="form-control inputClass"
                          placeholder="Nakład brutto"
                          required="required"
                          readonly="readonly"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">Papier</label>
                      <div class="col-sm-10">
                        <Multiselect
                          v-model="montageObj.paper_option"
                          mode="single"
                          placeholder="Papier"
                          label="name"
                          valueProp="value"
                          :close-on-select="true"
                          :searchable="true"
                          :options="papersOpt"
                        >
                        </Multiselect>
                        <div
                          v-if="sentForm && !montageObj.paper_option"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ montageObj.paper_option }}
                            To pole nie może być puste!
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">
                        Format arkusza
                      </label>
                      <div class="col-sm-10">
                        <Multiselect
                          v-model="montageObj.sheet_format"
                          mode="single"
                          placeholder="Format arkusza"
                          label="name"
                          valueProp="value"
                          :close-on-select="true"
                          :searchable="true"
                          :options="formatsOpt"
                        >
                        </Multiselect>
                        <div
                          v-if="sentForm && !montageObj.sheet_format"
                          class="has-error"
                        >
                          <span class="help-block">
                            To pole nie może być puste!
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">Płyta</label>
                      <div class="col-sm-10">
                        <Multiselect
                          v-model="montageObj.plate"
                          mode="single"
                          placeholder="Płyta"
                          label="name"
                          valueProp="value"
                          :close-on-select="true"
                          :searchable="true"
                          :options="platesOpt"
                        >
                        </Multiselect>
                        <div
                          v-if="errorsAdminData?.data?.plate"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.plate[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">Liczba płyt</label>
                      <div class="col-sm-10">
                        <input
                          v-model="montageObj.plate_quantity"
                          type="text"
                          class="form-control inputClass"
                          placeholder="Liczba płyt"
                          required="required"
                        />
                        <div
                          v-if="errorsAdminData?.data?.plate_quantity"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.plate_quantity[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="col-sm-offset-2 col-sm-10">
                        <div class="checkbox checkbox-primary">
                          <label>
                            <input
                              v-model="montageObj.flipped"
                              name="flipped"
                              type="checkbox"
                            />
                            <span>Arkusz na odwrotkę</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">
                        Wartość dodatkowa netto
                      </label>
                      <div class="col-sm-10">
                        <input
                          v-model="montageObj.extra_net"
                          type="number"
                          class="form-control inputClass"
                          placeholder="Wartość dodatkowa netto"
                          required="required"
                        />
                        <div
                          v-if="errorsAdminData?.data?.extra_net"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.extra_net[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">
                        Wymuszony termin realizacji
                      </label>
                      <div class="col-sm-10">
                        <VueDatePicker
                          :format="format"
                          v-model="montageObj.forced_deadline_date"
                        />
                        <div
                          v-if="errorsAdminData?.data?.forced_deadline_date"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.forced_deadline_date[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">Notatka</label>
                      <div class="col-sm-10 QuillEditor-box">
                        <QuillEditor
                          theme="snow"
                          contentType="html"
                          v-model:content="montageObj.info"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">
                        Oznaczenie zamówień Allegro
                      </label>
                      <div class="col-sm-10">
                        <input
                          v-model="montageObj.allegro_orders_marking"
                          type="text"
                          class="form-control inputClass"
                          placeholder="Np. prefiks / etykieta dla zamówień z Allegro"
                          maxlength="255"
                        />
                        <div
                          v-if="errorsAdminData?.data?.allegro_orders_marking"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.allegro_orders_marking[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">Status RW</label>
                      <div class="col-sm-10">
                        <Multiselect
                          v-model="montageObj.rw_status"
                          mode="single"
                          placeholder="Status RW"
                          track-by="name"
                          label="name"
                          :close-on-select="true"
                          :searchable="true"
                          :options="filterRWOptions"
                        >
                        </Multiselect>
                        <div
                          v-if="errorsAdminData?.data?.rw_status"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.rw_status[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">Papier RW</label>
                      <div class="col-sm-10">
                        <Multiselect
                          v-model="montageObj.rw_paper"
                          mode="single"
                          placeholder="Papier RW"
                          label="name"
                          valueProp="value"
                          :close-on-select="true"
                          :searchable="true"
                          :options="papersOpt"
                        >
                        </Multiselect>
                        <div
                          v-if="sentForm && !montageObj.rw_paper"
                          class="has-error"
                        >
                          <span class="help-block">
                            To pole nie może być puste!
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-2">
                        Notatka do rw
                      </label>
                      <div class="col-sm-10 QuillEditor-box">
                        <QuillEditor
                          theme="snow"
                          contentType="html"
                          v-model:content="montageObj.rw_note"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Działania</h5>
          </div>
          <div class="ibox-content">
            <div class="col-sm-10 col-sm-offset-2 mtop-30">
              <router-link class="btn btn-white" to="/montages/list">
                Anuluj
              </router-link>
              <button
                v-if="canChangeMontage"
                @click="saveEdit"
                class="btn btn-primary"
              >
                Zapisz
              </button>
            </div>
          </div>
        </div>

        <!-- Box Podsumowanie -->
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Podsumowanie</h5>
          </div>
          <div class="ibox-content">
            <dl class="dl-horizontal">
              <dt>Termin</dt>
              <dd>{{ formattedDeadline }}</dd>

              <dt>Liczba zleceń</dt>
              <dd>{{ nonSummaryRightCount }}</dd>

              <dt>Liczba zamówień</dt>
              <dd>{{ getUniqueOrdersCount() }}</dd>

              <dt>Wartość zleceń</dt>
              <dd>
                <span>{{ getMontageProductsPrice().toFixed(2) }}</span>
                <span>PLN</span>
              </dd>

              <dt>Koszt montażu</dt>
              <dd>
                <span>{{ totalMontageCost.toFixed(2) }}</span>
                <span>{{ montageObj.price_currency || "PLN" }}</span>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div class="row montages">
      <div class="col-lg-6">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Zlecenia oczekujące</h5>
          </div>
          <div v-if="items.left" class="ibox-content">
            <button @click="resetFilters" class="btn btn-primary btn-xs">
              <i class="fa fa-refresh"></i>
            </button>
            <button
              @click="moveItemsToRight"
              class="btn btn-sm btn-primary"
              type="button"
            >
              &gt;
            </button>
            <div style="margin-top: 8px">
              Ilość na stronę:
              <input
                type="number"
                min="1"
                :value="serverOptions.rowsPerPage"
                @change="updateRowsPerPage('left', $event.target.value)"
                style="
                  width: 90px;
                  margin-left: 8px;
                  border: 1px solid #ccc;
                  padding: 4px 8px;
                  margin-bottom: 5px;
                "
              />
            </div>
            <div class="pagination" v-if="itemsAll.left">
              <span class="items-all">
                Ilość rekordów: <b>{{ itemsAll.left }}</b>
              </span>
              <span>
                Ilość na stronę:
                <select v-model="serverOptions.rowsPerPage">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </span>
              <span>
                <input type="number" v-model="serverOptions.page" /> -
                {{ Math.ceil(itemsAll.left / serverOptions.rowsPerPage) }}
              </span>

              <button
                @click="serverOptions.page = serverOptions.page - 1"
                :disabled="serverOptions.page === 1"
                class="prev"
              ></button>
              <button
                @click="serverOptions.page = serverOptions.page + 1"
                :disabled="
                  serverOptions.page ===
                  Math.ceil(itemsAll / serverOptions.rowsPerPage)
                "
                class="next"
              ></button>
            </div>
            <div class="table-responsive table-search native-table-search">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th class="select-column">
                      <input
                        type="checkbox"
                        :checked="isAllLeftSelected"
                        @change="toggleSelectAllLeft($event.target.checked)"
                      />
                    </th>
                    <th
                      v-for="header in headers"
                      :key="header.value"
                      :class="[
                        'native-header-cell',
                        leftHeaderClass(header.value),
                        { sortable: header.sortable },
                      ]"
                    >
                      <div class="native-header-content">
                        <button
                          type="button"
                          class="native-sort-button"
                          @click="toggleLeftSort(header)"
                        >
                          <span>{{ header.text }}</span>
                          <i
                            :class="[
                              'sort-icon',
                              'fa',
                              leftSortIconClass(header.value),
                              inactiveLeftSortClass(header),
                            ]"
                          ></i>
                        </button>
                        <input
                          v-if="header.search"
                          v-model="
                            searchValue[
                              header.s_value ? header.s_value : header.value
                            ]
                          "
                          class="table-search native-header-input"
                          type="text"
                          @keyup="search"
                          @click.stop="isSearch = true"
                        />
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td :colspan="headers.length + 1" class="text-center">
                      Ładowanie...
                    </td>
                  </tr>
                  <tr v-else-if="!items.left.length">
                    <td :colspan="headers.length + 1" class="text-center">
                      Brak wyników
                    </td>
                  </tr>
                  <template v-else>
                    <tr
                      v-for="item in items.left"
                      :key="`left-${item.pk}-${item.lp}`"
                      :class="getLeftRowClass(item)"
                    >
                      <td class="select-column">
                        <input
                          v-if="isValidLeftRow(item)"
                          type="checkbox"
                          :checked="isLeftRowSelected(item.pk)"
                          @change="
                            toggleLeftRowSelection(item, $event.target.checked)
                          "
                        />
                      </td>
                      <template v-if="item?.isSummary">
                        <td colspan="6"></td>
                        <td>
                          <strong>
                            {{
                              Number(
                                item.selected_quantity__quantity ||
                                  item.selected_quantity ||
                                  0
                              ).toFixed(0)
                            }}
                          </strong>
                        </td>
                        <td></td>
                        <td>
                          <strong>
                            {{ formatSummaryValue(item.net_price) }}
                          </strong>
                        </td>
                        <td></td>
                        <td>
                          <strong>{{ formatSummaryValue(item.weight) }}</strong>
                        </td>
                        <td></td>
                        <td></td>
                      </template>
                      <template v-else>
                        <td>{{ item.lp }}</td>
                        <td>
                          <div class="pfile-prevs">
                            <img
                              :src="item?.product_file?.client_file_thumbnail"
                              width="40px"
                              class="pointer"
                              @click="preview(item)"
                            />
                            <img
                              v-if="item?.product_file?.client_file_thumbnail_2"
                              :src="item?.product_file?.client_file_thumbnail_2"
                              width="40px"
                              class="pointer"
                              @click="preview(item)"
                            />
                          </div>
                        </td>
                        <td>
                          <span
                            class="chosen-pk"
                            @mouseenter="showChosenOptions(item.pk)"
                            @mouseleave="hideChosenOptions"
                          >
                            {{ item.pk_with_count }}
                            <div v-if="isChosenOptionsVisible(item.pk)">
                              <div class="popover-content">
                                <div class="row">
                                  <div class="col-sm-3">
                                    <strong><span>ID zlecenia</span></strong>
                                  </div>
                                  <div class="col-sm-9">
                                    <span>{{ item.pk_with_count }}</span>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-3">
                                    <strong>
                                      <span>Nr zamówienia</span>
                                    </strong>
                                  </div>
                                  <div class="col-sm-9">
                                    <span>{{ item.order_pk }}</span>
                                  </div>
                                </div>
                                <div
                                  v-for="(option, key) in chosenRows(item)"
                                  :key="key"
                                  class="row"
                                >
                                  <div class="col-sm-3">
                                    <strong>
                                      <span>Opcje</span>
                                    </strong>
                                  </div>
                                  <div class="col-sm-9">
                                    <span class="show m-b-xs">
                                      <span class="m-r-xs label label-default">
                                        {{ option.chosen_option.group_pk }}
                                      </span>
                                      <span class="m-r-xs">
                                        {{ option.chosen_option.group_name }}
                                      </span>
                                      <span class="m-r-xs label label-default">
                                        {{ option.chosen_option.pk }}
                                      </span>
                                      <span class="m-r-xs">
                                        {{ option.chosen_option.label }}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-else-if="isChosenOptionsLoading(item.pk)">
                              <div class="popover-content">
                                {{ loadingOptionsText }}
                              </div>
                            </div>
                          </span>
                          <FontAwesomeIcon
                            v-if="item?.locked_info"
                            :icon="['fas', 'file']"
                            title="Zawiera notatkę"
                            class="table-helper-item"
                          />
                          <FontAwesomeIcon
                            v-if="item?.is_locked"
                            :icon="['fas', 'print']"
                            title='Wymuszony status "W·produkcji"'
                            class="table-helper-item"
                          />
                        </td>
                        <td>
                          <router-link
                            :to="{
                              name: 'OrderDetails',
                              params: { pk: item.order_pk },
                            }"
                          >
                            {{ item.order_pk }}
                          </router-link>
                        </td>
                        <td>{{ item.product_pk }}</td>
                        <td>{{ item.product_name }}</td>
                        <td>{{ item.selected_quantity }}</td>
                        <td>{{ item.product_format }}</td>
                        <td>{{ item.net_price }}</td>
                        <td>{{ item.currency }}</td>
                        <td>{{ item.weight }}</td>
                        <td>
                          {{
                            item.order_realization_date ||
                            item.order__realization_date ||
                            "-"
                          }}
                        </td>
                        <td>
                          <div
                            class="actions-dropdown"
                            @mouseenter="showActionsMenu(item.pk)"
                            @mouseleave="hideActionsMenu(item.pk)"
                          >
                            <button :class="actionsToggleClass">
                              <i class="fa fa-ellipsis-h"></i>
                            </button>
                            <div
                              class="actions-menu"
                              v-show="activeActionsMenu === item.pk"
                            >
                              <button
                                @click="edit(item)"
                                class="btn btn-warning btn-xs action-item"
                                title="Edytuj"
                              >
                                <i class="fa fa-list-alt"></i> Edytuj
                              </button>
                              <button
                                @click="getAdminCard(item.order_pk)"
                                class="btn btn-primary btn-xs action-item"
                                title="Pobierz kartę zamówienia"
                              >
                                <i class="fa fa-list-alt"></i> Karta zamówienia
                              </button>
                              <button
                                :disabled="isClientFileNotAvailable(item)"
                                @click="
                                  getOrderProductFiles(
                                    getPreflightFilePk(item),
                                    '/get_client_file/'
                                  )
                                "
                                class="btn btn-xs action-item"
                                title="Plik Klienta"
                              >
                                <i class="fa fa-user"></i> Plik Klienta
                              </button>
                              <button
                                :disabled="isResultFileNotAvailable(item)"
                                @click="
                                  getOrderProductFiles(
                                    getPreflightFilePk(item),
                                    '/get_result_file/'
                                  )
                                "
                                class="btn btn-xs action-item"
                                title="Plik wyjściowy"
                              >
                                <i class="fa fa-search"></i> Plik wyjściowy
                              </button>
                              <button
                                v-if="!isClientCoverFileNotAvailable(item)"
                                @click="
                                  getOrderProductFiles(
                                    getPreflightFilePk(item),
                                    '/get_client_cover_file/'
                                  )
                                "
                                class="btn btn-xs action-item"
                                title="Plik okładki klienta"
                              >
                                <i class="fa fa-user"></i> Plik okładki klienta
                              </button>
                              <button
                                v-if="!isCoverResultFileNotAvailable(item)"
                                @click="
                                  getOrderProductFiles(
                                    getPreflightFilePk(item),
                                    '/get_cover_result_file/'
                                  )
                                "
                                class="btn btn-xs action-item"
                                title="Plik okładki wyjściowy"
                              >
                                <i class="fa fa-search"></i> Plik okładki
                                wyjściowy
                              </button>
                            </div>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <div class="pagination" v-if="itemsAll.left">
              <span class="items-all">
                Ilość rekordów: <b>{{ itemsAll.left }}</b>
              </span>
              <span>
                Ilość na stronę:
                <select v-model="serverOptions.rowsPerPage">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </span>
              <span>
                <input type="number" v-model="serverOptions.page" /> -
                {{ Math.ceil(itemsAll.left / serverOptions.rowsPerPage) }}
              </span>

              <button
                @click="serverOptions.page = serverOptions.page - 1"
                :disabled="serverOptions.page === 1"
                class="prev"
              ></button>
              <button
                @click="serverOptions.page = serverOptions.page + 1"
                :disabled="
                  serverOptions.page ===
                  Math.ceil(itemsAll / serverOptions.rowsPerPage)
                "
                class="next"
              ></button>
            </div>
            <div class="form-horizontal mtop-30">
              <div v-if="canDisplayMontagesSites" class="form-group">
                <label class="control-label col-sm-2">Domena</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filterSite"
                    mode="single"
                    placeholder="Domena"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="sites"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Źródło</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersLeft.source"
                    mode="tags"
                    placeholder="Źródło"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="filterSourceOptions"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Status zamówienia</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersLeft.order_statuses"
                    mode="tags"
                    placeholder="Status zamówienia"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="filterStatusses"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Format</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersLeft.format"
                    mode="tags"
                    placeholder="Format"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="formats.left"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Nakład</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersLeft.quantities"
                    mode="tags"
                    placeholder="Nakład"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="quantities.left"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Papier</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersLeft.paper"
                    mode="tags"
                    placeholder="Papier"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="papers.left"
                  >
                  </Multiselect>
                </div>
              </div>
              <div
                v-for="(filter, index) in montageFilters.left"
                :key="index"
                class="form-group"
              >
                <label class="control-label col-sm-2">
                  {{ filter.siteName }}
                  {{ filter.name }}
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersLeft[filter.filterId]"
                    mode="tags"
                    :placeholder="filter.name"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="filter.product_options"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Zlecenia dodane do montażu</h5>
          </div>
          <div class="ibox-content">
            <button @click="moveItemsToLeft" class="btn btn-sm btn-primary">
              &lt;
            </button>

            <!-- Stronicowanie na górze -->
            <div class="pagination" v-if="itemsAll.right">
              <span class="items-all">
                Ilość rekordów: <b>{{ itemsAll.right }}</b>
              </span>
              <span>
                Ilość na stronę:
                <select v-model="serverOptionsRight.rowsPerPage">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </span>
              <span>
                <input type="number" v-model="serverOptionsRight.page" /> -
                {{ Math.ceil(itemsAll.right / serverOptionsRight.rowsPerPage) }}
              </span>

              <button
                @click="serverOptionsRight.page = serverOptionsRight.page - 1"
                :disabled="serverOptionsRight.page === 1"
                class="prev"
              ></button>
              <button
                @click="serverOptionsRight.page = serverOptionsRight.page + 1"
                :disabled="
                  serverOptionsRight.page ===
                  Math.ceil(itemsAll.right / serverOptionsRight.rowsPerPage)
                "
                class="next"
              ></button>
            </div>

            <EasyDataTable
              v-model:server-options="serverOptionsRight"
              :server-items-length="itemsAll.right"
              v-model:items-selected="itemsRightSelected"
              :body-row-class-name="bodyRowClassNameFunction"
              :headers="headers"
              :items="items.right"
              :loading="loading1"
              alternating
              multi-sort
              border-cell
              class="table-search"
            >
              <template #header="header">
                <span v-if="header.text" @click="updateSort">
                  {{ header.text }}
                </span>
                <input
                  class="table-search"
                  type="text"
                  v-if="header.search"
                  v-model="searchValue1[header.value]"
                  @keyup="search"
                  @click="isSearch = true"
                />
              </template>
              <template #item-id="item">
                <span
                  class="chosen-pk"
                  @mouseenter="showChosenOptions(item.pk)"
                  @mouseleave="hideChosenOptions"
                >
                  {{ item.pk_with_count }}
                  <div v-if="isChosenOptionsVisible(item.pk)">
                    <div class="popover-content">
                      <div class="row">
                        <div class="col-sm-3">
                          <strong><span>ID zlecenia</span></strong>
                        </div>
                        <div class="col-sm-9">
                          <span>{{ item.pk_with_count }}</span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-3">
                          <strong>
                            <span>Nr zamówienia</span>
                          </strong>
                        </div>
                        <div class="col-sm-9">
                          <span>{{ item.order_pk }}</span>
                        </div>
                      </div>
                      <div
                        v-for="(option, key) in getChosenOptionsRows(item.pk)"
                        :key="key"
                        class="row"
                      >
                        <div class="col-sm-3">
                          <strong>
                            <span>Opcje</span>
                          </strong>
                        </div>
                        <div class="col-sm-9">
                          <span class="show m-b-xs">
                            <span class="m-r-xs label label-default">
                              {{ option.chosen_option.group_pk }}
                            </span>
                            <span class="m-r-xs">
                              {{ option.chosen_option.group_name }}
                            </span>
                            <span class="m-r-xs label label-default">
                              {{ option.chosen_option.pk }}
                            </span>
                            <span class="m-r-xs">
                              {{ option.chosen_option.label }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="isChosenOptionsLoading(item.pk)">
                    <div class="popover-content">Ładowanie opcji...</div>
                  </div>
                </span>
              </template>
              <template #item-image="item">
                <img
                  :src="item?.product_file?.client_file_thumbnail"
                  width="40px"
                  class="pointer"
                  @click="preview(item)"
                />
                <img
                  v-if="item?.product_file?.client_file_thumbnail_2"
                  :src="item?.product_file?.client_file_thumbnail_2"
                  width="40px"
                  class="pointer"
                  @click="preview(item)"
                />
              </template>
              <template #item-selected_quantity__quantity="item">
                {{ item.selected_quantity }}
              </template>
              <template #item-order_pk="item">
                <router-link
                  v-if="!item?.isSummary && item.order_pk"
                  :to="{ name: 'OrderDetails', params: { pk: item.order_pk } }"
                >
                  {{ item.order_pk }}
                </router-link>
              </template>
              <template #item-order__realization_date="item">
                {{
                  item.order_realization_date ||
                  item.order__realization_date ||
                  "-"
                }}
              </template>
              <template #item-actions="item">
                <div
                  v-if="!item?.isSummary"
                  class="actions-dropdown"
                  @mouseenter="showActionsMenu(item.pk)"
                  @mouseleave="hideActionsMenu(item.pk)"
                >
                  <button class="btn btn-default btn-xs actions-toggle">
                    <i class="fa fa-ellipsis-h"></i>
                  </button>
                  <div
                    class="actions-menu"
                    v-show="activeActionsMenu === item.pk"
                  >
                    <button
                      @click="edit(item)"
                      class="btn btn-warning btn-xs action-item"
                      title="Edytuj"
                    >
                      <i class="fa fa-list-alt"></i> Edytuj
                    </button>
                    <button
                      @click="getAdminCard(item.order_pk)"
                      class="btn btn-primary btn-xs action-item"
                      title="Pobierz kartę zamówienia"
                    >
                      <i class="fa fa-list-alt"></i> Karta zamówienia
                    </button>
                    <button
                      :disabled="isClientFileNotAvailable(item)"
                      @click="
                        getOrderProductFiles(
                          item?.product_file?.preflight_status?.file_pk,
                          '/get_client_file/'
                        )
                      "
                      class="btn btn-xs action-item"
                      title="Plik Klienta"
                    >
                      <i class="fa fa-user"></i> Plik Klienta
                    </button>
                    <button
                      :disabled="isResultFileNotAvailable(item)"
                      @click="
                        getOrderProductFiles(
                          item?.product_file?.preflight_status?.file_pk,
                          '/get_result_file/'
                        )
                      "
                      class="btn btn-xs action-item"
                      title="Plik wyjściowy"
                    >
                      <i class="fa fa-search"></i> Plik wyjściowy
                    </button>
                    <button
                      v-if="!isClientCoverFileNotAvailable(item)"
                      @click="
                        getOrderProductFiles(
                          item?.product_file?.preflight_status?.file_pk,
                          '/get_client_cover_file/'
                        )
                      "
                      class="btn btn-xs action-item"
                      title="Plik okładki klienta"
                    >
                      <i class="fa fa-user"></i> Plik okładki klienta
                    </button>
                    <button
                      v-if="!isCoverResultFileNotAvailable(item)"
                      @click="
                        getOrderProductFiles(
                          item?.product_file?.preflight_status?.file_pk,
                          '/get_cover_result_file/'
                        )
                      "
                      class="btn btn-xs action-item"
                      title="Plik okładki wyjściowy"
                    >
                      <i class="fa fa-search"></i> Plik okładki wyjściowy
                    </button>
                  </div>
                </div>
              </template>
            </EasyDataTable>

            <!-- Stronicowanie na dole -->
            <div class="pagination" v-if="itemsAll.right">
              <span class="items-all">
                Ilość rekordów: <b>{{ itemsAll.right }}</b>
              </span>
              <span>
                Ilość na stronę:
                <select v-model="serverOptionsRight.rowsPerPage">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </span>
              <span>
                <input type="number" v-model="serverOptionsRight.page" /> -
                {{ Math.ceil(itemsAll.right / serverOptionsRight.rowsPerPage) }}
              </span>

              <button
                @click="serverOptionsRight.page = serverOptionsRight.page - 1"
                :disabled="serverOptionsRight.page === 1"
                class="prev"
              ></button>
              <button
                @click="serverOptionsRight.page = serverOptionsRight.page + 1"
                :disabled="
                  serverOptionsRight.page ===
                  Math.ceil(itemsAll.right / serverOptionsRight.rowsPerPage)
                "
                class="next"
              ></button>
            </div>

            <br />
            <div class="form-horizontal mtop-30">
              <div v-if="canDisplayMontagesSites" class="form-group">
                <label class="control-label col-sm-2">Domena</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersRight.site"
                    mode="single"
                    placeholder="Domena"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="sites"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Status zamówienia</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersRight.order_statuses"
                    mode="tags"
                    placeholder="Status zamówienia"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="filterStatusses"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Format</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersRight.format"
                    mode="tags"
                    placeholder="Format"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="formats.right"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Nakład</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersRight.quantities"
                    mode="tags"
                    placeholder="Nakład"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="quantities.right"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Papier</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersRight.paper"
                    mode="tags"
                    placeholder="Papier"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="papers.right"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Źródło</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersRight.source"
                    mode="tags"
                    placeholder="Źródło"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="filterSourceOptions"
                  >
                  </Multiselect>
                </div>
              </div>
              <div
                v-for="(filter, index) in montageFilters.right"
                :key="index"
                class="form-group"
              >
                <label class="control-label col-sm-2">
                  {{ filter.site_name }}
                  {{ filter.name }}
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="filtersRight[filter.filterId]"
                    mode="tags"
                    :placeholder="filter.name"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="filter.product_options"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mActions" class="modal-dialog realization">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Wymuszenie produkcji</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group">
                  <div class="col-sm-offset-2 col-sm-10">
                    <div class="checkbox checkbox-primary">
                      <label>
                        <input v-model="editObj.is_locked" type="checkbox" />
                        <span>Wymuś status w produkcji</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-sm-2">Notatka</label>
                  <div class="col-sm-10 QuillEditor-box">
                    <QuillEditor
                      theme="snow"
                      contentType="text"
                      v-model:content="editObj.locked_info"
                    />
                    <div
                      v-if="errorsAdminData?.data?.locked_info"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ errorsAdminData.data.locked_info[0] }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-4 col-sm-offset-2">
                    <button @click="mActions = false" class="btn btn-white">
                      Anuluj
                    </button>
                    <button
                      @click="updateMontageProduct"
                      class="btn btn-primary"
                    >
                      Zapisz
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mActions" @click="mActions = false" class="modal-backdrop"></div>
  <Modal
    v-if="duplicateConfirmPk"
    :title="'Potwierdzenie działania'"
    :content="duplicateConfirmContent"
    @callbackOk="duplicateMontage"
    @callbackClose="duplicateConfirmPk = false"
  />
  <div v-if="mPreview" id="prv" class="modal-dialog preflight">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Podgląd pliku</h4>
        </div>
        <div v-if="previewData?.preview?.product_file" class="modal-body">
          <pdfViewer
            :read-only="!previewData.is_allegro_source"
            :order-product-file="previewData.preview.product_file"
            :gross-size="previewData.preview.product_gross_size"
            :bleed="previewData.product_bleed"
            :text-margin="previewData.product_text_margin"
            :product-kind="previewData.product_kind"
            :tech-lines="previewData.preview.tech_lines"
            :booklet-uv="previewData.preview.is_booklet_uv"
            :pages-loaded="0"
            :loading="true"
            loading-text="Ładowanie stron"
            @close-preview="mPreview = false"
            @scroll-to-preview="scrollToPreview"
          />
        </div>
        <div class="modal-footer">
          <button @click="mPreview = false" class="btn btn-white">
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mPreview" @click="mPreview = false" class="modal-backdrop"></div>

  <div
    v-if="mActions1 && realizationMontage?.pk"
    class="modal-dialog realization"
  >
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">
            Realizacja montażu nr:
            {{ realizationMontage.pk }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="panel-body">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="ibox">
                      <button
                        v-if="canSetStatus('closed')"
                        @click="
                          endProcess(
                            realizationMontage.pk,
                            !realizationMontage.closed,
                            'closed'
                          )
                        "
                        class="btn"
                        :class="{
                          'btn-primary': realizationMontage.closed,
                          'btn-default': !realizationMontage.closed,
                        }"
                      >
                        <i
                          v-if="realizationMontage.closed"
                          class="fa fa-check"
                        ></i>
                        <i v-else class="fa fa-times"></i>
                        <span> Zamknięty</span>
                      </button>

                      <button
                        v-if="canSetStatus('mounted')"
                        @click="
                          endProcess(
                            realizationMontage.pk,
                            !realizationMontage.mounted,
                            'mounted'
                          )
                        "
                        :disabled="realizationMontage.radiated"
                        class="btn"
                        :class="{
                          'btn-primary': realizationMontage.mounted,
                          'btn-default': !realizationMontage.mounted,
                        }"
                      >
                        <i
                          v-if="realizationMontage.mounted"
                          class="fa fa-check"
                        ></i>
                        <i v-else class="fa fa-times"></i>
                        <span> Zmontowany</span>
                      </button>

                      <button
                        v-if="canSetStatus('radiated')"
                        @click="
                          endProcess(
                            realizationMontage.pk,
                            !realizationMontage.radiated,
                            'radiated'
                          )
                        "
                        :disabled="realizationMontage.printed"
                        class="btn"
                        :class="{
                          'btn-primary': realizationMontage.radiated,
                          'btn-default': !realizationMontage.radiated,
                        }"
                      >
                        <i
                          v-if="realizationMontage.radiated"
                          class="fa fa-check"
                        ></i>
                        <i v-else class="fa fa-times"></i>
                        <span> Naświetlony</span>
                      </button>

                      <button
                        v-if="canSetStatus('printed')"
                        @click="
                          endProcess(
                            realizationMontage.pk,
                            !realizationMontage.printed,
                            'printed'
                          )
                        "
                        class="btn"
                        :class="{
                          'btn-primary': realizationMontage.printed,
                          'btn-default': !realizationMontage.printed,
                        }"
                      >
                        <i
                          v-if="realizationMontage.printed"
                          class="fa fa-check"
                        ></i>
                        <i v-else class="fa fa-times"></i>
                        <span> Wydrukowany</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row-eq-height row">
                  <div v-if="showProcessBox('closed')" class="col-md-3">
                    <div
                      class="nomargin height-100-pc widget lazur-bg p-xl"
                      :class="{ 'unactive-cube': realizationMontage.closed }"
                    >
                      <b>
                        <h2 v-if="realizationMontage.closed">Zamknięty</h2>
                        <h2 v-else>Zamykanie</h2>
                        <small v-if="realizationMontage.closed">
                          Poprzedni etap
                        </small>
                        <small v-else-if="!realizationMontage.closed">
                          Aktualny etap
                        </small>
                      </b>
                    </div>
                  </div>
                  <div v-if="showProcessBox('mounted')" class="col-md-3">
                    <div
                      class="nomargin height-100-pc widget lazur-bg p-xl"
                      :class="{
                        'unactive-cube':
                          currentProcess() !== 'mounted' ||
                          realizationMontage.mounted,
                      }"
                    >
                      <b>
                        <h2 v-if="realizationMontage?.mounted">Zmontowany</h2>
                        <h2 v-else>Montaż</h2>
                        <small v-if="realizationMontage?.mounted">
                          Poprzedni etap
                        </small>
                        <small
                          v-else-if="
                            realizationMontage.closed &&
                            !realizationMontage.mounted
                          "
                        >
                          Aktualny etap
                        </small>
                        <small v-else>Następny etap</small>
                      </b>
                    </div>
                  </div>
                  <div v-if="showProcessBox('radiated')" class="col-md-3">
                    <div
                      class="nomargin height-100-pc widget lazur-bg p-xl"
                      :class="{
                        'unactive-cube':
                          currentProcess() !== 'radiated' ||
                          realizationMontage.radiated,
                      }"
                    >
                      <b>
                        <h2 v-if="realizationMontage.radiated">Naświetlony</h2>
                        <h2 v-else>Naświetlanie</h2>
                        <small v-if="realizationMontage.radiated">
                          Poprzedni etap
                        </small>
                        <small v-else-if="realizationMontage.mounted">
                          Aktualny etap
                        </small>
                        <small v-else>Następny etap</small>
                      </b>
                    </div>
                  </div>

                  <div v-if="showProcessBox('printed')" class="col-md-3">
                    <div
                      class="nomargin height-100-pc widget lazur-bg p-xl"
                      :class="{
                        'unactive-cube': currentProcess() !== 'printed',
                      }"
                    >
                      <b>
                        <h2 v-if="realizationMontage.printed">Wydrukowany</h2>
                        <h2 v-else>Drukowanie</h2>
                        <small v-if="currentProcess() === 'printed'">
                          Aktualny etap
                        </small>
                        <small v-else>Następny etap</small>
                      </b>
                    </div>
                  </div>

                  <div class="col-md-3 border-left">
                    <div class="btn-group-vertical">
                      <button
                        @click="startProcess(realizationMontage.pk)"
                        :disabled="
                          !canChangeCurrentStatus() ||
                          realizationMontage.realization_started ||
                          realizationMontage.printed
                        "
                        class="btn btn-primary"
                      >
                        <span class="fa fa-play"></span>
                        <span> Rozpoczęcie pracy</span>
                      </button>
                      <button
                        @click="endProcess(realizationMontage.pk, true)"
                        class="btn btn-primary"
                        :disabled="
                          !canChangeCurrentStatus() ||
                          !realizationMontage.realization_started ||
                          realizationMontage.printed
                        "
                      >
                        <span class="fa fa-stop"></span>
                        <span> Zakończenie pracy</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mActions1 = false" class="btn btn-white">
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mActions1" @click="mActions1 = false" class="modal-backdrop"></div>
</template>

<script>
import { computed, ref, watch, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { montagePermissionsConst } from "../../constants/productionConstants";
import router from "../../router/router";
import { useRoute } from "vue-router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import pdfViewer from "../pdfViewer/pdfViewer.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { montageProductRowClassName as bodyRowClassNameFunction } from "./montageAllegroRow";
import Modal from "../caffeprint/Modal.vue";
import { useMontageDuplicate } from "./useMontageDuplicate";

export default {
  name: "MontagesEdit",
  mixins: [],
  components: {
    Multiselect,
    pdfViewer,
    VueDatePicker,
    FontAwesomeIcon,
    Modal,
  },
  props: {},

  setup() {
    const store = useStore();
    const canChangeMontage = computed(() =>
      hasPermission(montagePermissionsConst.update)
    );
    // Filtering order products by domain needs the permission to view
    // montages from other sites, like in the old panel.
    const canDisplayMontagesSites = computed(() =>
      hasPermission(montagePermissionsConst.view_montage_from_sites_permission)
    );
    const montageProductsData = computed(
      () => store.getters.getMontageProductsData
    );
    const montageFilterGroupData = computed(
      () => store.getters.getMontageFilterGroupData
    );
    const sitesData = computed(() => store.getters.getSitesData);
    const formatData = computed(() => store.getters.getMontageFormatData);
    const quantityData = computed(() => store.getters.getMontageQuantitiesData);
    const paperOptionsData = computed(
      () => store.getters.getMontagePaperOptionsData
    );
    const papersData = computed(() => store.getters.getMontagePapersData);
    const formatsData = computed(() => store.getters.getMontageFormatsData);
    const platesData = computed(() => store.getters.getMontagePlatesData);
    const montageData = computed(() => store.getters.getMontageData);
    const orderProductsFileData = computed(
      () => store.getters.getOrderProductsFileData
    );
    const updateMontageData = computed(
      () => store.getters.getUpdateMontageData
    );
    const updateMontageProductData = computed(
      () => store.getters.getUpdateMontageProductData
    );
    const montageProcessData = computed(
      () => store.getters.getMontageProcessData
    );
    const chosenOptionsData = computed(
      () => store.getters.getChosenOptionsData
    );
    const realizationMontage = ref({});
    const route = useRoute();
    const errorsAdminData = ref();
    const activeActionsMenu = ref(null);
    const activeChosenPk = ref(null);
    const chosenOptionsLoadingPk = ref(null);
    const chosenOptionsCache = ref({});
    const montageObj = ref({
      montage_products: [],
      paper_option: null,
      sheet_format: null,
      plate: null,
      rw_paper: null,
      allegro_orders_marking: "",
    });
    const editObj = ref();
    const searchValue = ref({});
    const searchValue1 = ref({});
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });
    const serverOptionsRight = ref({
      page: 1,
      rowsPerPage: 25,
    });
    const loading = ref(true);
    const loading1 = ref(false);
    const isSearch = ref(false);
    const mActions = ref(false);
    const mActions1 = ref(false);
    const mPreview = ref(false);
    const sentForm = ref(false);
    const itemsSelected = ref([]);
    const itemsRightSelected = ref([]);
    const filtersLeft = ref({ order_statuses: ["in_realization"] });
    const filtersRight = ref({});
    const sites = ref([]);
    const papersOpt = ref([]);
    const formatsOpt = ref([]);
    const platesOpt = ref([]);
    const filterSite = ref();
    const siteFilterInitialized = ref(false);
    const previewData = ref({});
    const processBox = ref(false);
    const montageFilters = ref({
      left: [],
      right: [],
    });
    const formats = ref({
      left: [],
      right: [],
    });
    const quantities = ref({
      left: [],
      right: [],
    });
    const papers = ref({
      left: [],
      right: [],
    });
    const items = ref({
      left: [],
      right: [],
    });
    const itemsAll = ref({
      left: 0,
      right: 0,
    });
    const lastProcess = ref({
      type: "",
      val: "",
    });

    let headers = [
      { text: "Lp", value: "lp", sortable: false },
      {
        text: "Podgląd",
        value: "image",
        sortable: false,
        search: false,
      },
      {
        text: "ID zlecenia",
        value: "id",
        s_value: "id",
        ordering_value: "pk",
        sortable: true,
        search: true,
      },
      {
        text: "Numer Zamówienia",
        value: "order_pk",
        ordering_value: "order__pk",
        sortable: true,
        search: true,
      },
      {
        text: "ID produktu",
        value: "product_pk",
        ordering_value: "product__pk",
        sortable: true,
        search: true,
      },
      {
        text: "Produkt",
        value: "product_name",
        ordering_value: "product__name",
        sortable: true,
        search: true,
      },
      {
        text: "Nakład",
        value: "selected_quantity__quantity",
        s_value: "selected_quantity",
        search: true,
        sortable: true,
      },
      { text: "Format", value: "product_format", sortable: true, search: true },
      { text: "Netto", value: "net_price", sortable: true },
      { text: "Waluta", value: "currency", sortable: true },
      { text: "Waga", value: "weight", sortable: true },
      {
        text: "Termin realizacji",
        value: "order__realization_date",
        sortable: true,
        search: true,
      },
      { text: "Akcje", value: "actions" },
    ];
    const filterRWOptions = ref([
      { name: "Oczekuje na wystawienie RW", value: "awaiting" },
      { name: "RW wystawione automatycznie", value: "auto_issued" },
      { name: "RW wystawione ręcznie", value: "manual_issued" },
      { name: "RW niewystawione automatycznie", value: "auto_not_issued" },
    ]);
    const filterStatusses = ref([
      { name: "Oczekuje na płatność", value: "waiting_for_payment" },
      { name: "W realizacji", value: "in_realization" },
      { name: "W produkcji", value: "in_production" },
      { name: "Oczekuje na podgląd", value: "waiting_for_preflight" },
    ]);
    const filterSourceOptions = ref([
      { name: "Wewnętrzne", value: "internal" },
      { name: "Zewnętrzne", value: "external" },
      { name: "Allegro", value: "allegro" },
    ]);
    const leftSelectedPks = ref([]);

    const isValidLeftRow = (row) =>
      !!row && !row.isSummary && Number.isInteger(Number(row?.pk));

    // Full rows of every product belonging to the montage, like
    // productsRightOriginal in the old panel. The right table only ever holds
    // the current page, so the summary box has to be counted from here instead.
    const selectedProducts = ref([]);

    const syncMontageProductPks = () => {
      montageObj.value.montage_products = selectedProducts.value.map((row) =>
        Number(row.pk)
      );
    };

    const isProductSelected = (pk) =>
      selectedProducts.value.some((row) => Number(row.pk) === Number(pk));

    const allLeftSelectablePks = computed(() =>
      (items.value.left || [])
        .filter((row) => isValidLeftRow(row))
        .map((row) => Number(row.pk))
    );

    const isAllLeftSelected = computed(
      () =>
        allLeftSelectablePks.value.length > 0 &&
        allLeftSelectablePks.value.every((pk) =>
          leftSelectedPks.value.includes(pk)
        )
    );

    const syncLeftSelectedRows = () => {
      const selected = new Set(leftSelectedPks.value);
      itemsSelected.value = (items.value.left || []).filter(
        (row) => isValidLeftRow(row) && selected.has(Number(row.pk))
      );
    };

    const isLeftRowSelected = (pk) =>
      leftSelectedPks.value.includes(Number(pk));

    const toggleLeftRowSelection = (row, checked) => {
      const pk = Number(row?.pk);
      if (!Number.isInteger(pk)) {
        return;
      }
      if (checked) {
        if (!leftSelectedPks.value.includes(pk)) {
          leftSelectedPks.value.push(pk);
        }
      } else {
        leftSelectedPks.value = leftSelectedPks.value.filter((x) => x !== pk);
      }
      syncLeftSelectedRows();
    };

    const toggleSelectAllLeft = (checked) => {
      leftSelectedPks.value = checked ? [...allLeftSelectablePks.value] : [];
      syncLeftSelectedRows();
    };

    const toggleLeftSort = (header) => {
      if (!header?.sortable) {
        return;
      }

      const value = header.ordering_value ?? header.value;
      if (serverOptions.value.sortBy === value) {
        serverOptions.value.sortType =
          serverOptions.value.sortType === "desc" ? "asc" : "desc";
      } else {
        serverOptions.value.sortBy = value;
        serverOptions.value.sortType = "asc";
      }
    };

    const isLeftSortedHeader = (value) => serverOptions.value.sortBy === value;
    const isLeftSortInactive = (header) => !isLeftSortedHeader(header?.value);
    const inactiveLeftSortClass = (header) =>
      isLeftSortInactive(header) ? "sort-icon--inactive" : "";
    const leftSortIconClass = (value) =>
      !isLeftSortedHeader(value)
        ? "fa-sort"
        : serverOptions.value.sortType === "desc"
        ? "fa-arrow-down"
        : "fa-arrow-up";
    const leftHeaderClass = (value) => {
      const classMap = {
        lp: "col-lp",
        image: "col-image",
        id: "col-id",
        order_pk: "col-order",
        product_pk: "col-product-pk",
        selected_quantity__quantity: "col-qty",
        net_price: "col-net",
        currency: "col-currency",
        weight: "col-weight",
        actions: "col-actions",
      };
      return classMap[value] || "";
    };

    const mapMontageSortField = (sortField) => {
      if (!sortField) {
        return sortField;
      }
      if (sortField === "selected_quantity__quantity") {
        return "selected_quantity__display_quantity";
      }
      if (sortField === "-selected_quantity__quantity") {
        return "-selected_quantity__display_quantity";
      }
      return sortField;
    };

    const getMontageProducts = (right = false) => {
      if (!right && !siteFilterInitialized.value) {
        return;
      }
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      sort = mapMontageSortField(sort);
      if (!right) {
        loading.value = true;
        store.dispatch("getMontageProducts", {
          page: serverOptions.value.page,
          itemsPerPage: serverOptions.value.rowsPerPage,
          ordering: sort,
          search: searchValue.value,
          site_pk: filterSite.value,
          filters: filtersLeft.value,
          exclude: montageObj.value.montage_products,
          right: false,
        });
      } else {
        loading1.value = true;
        store.dispatch("getMontageProducts", {
          page: serverOptionsRight.value.page,
          itemsPerPage: serverOptionsRight.value.rowsPerPage,
          ordering: sort,
          search: searchValue1.value,
          site_pk: filtersRight.value.site,
          filters: filtersRight.value,
          exclude: montageObj.value.montage_products,
          right: true,
        });
      }
    };

    const format = (date) => {
      // If date is already a string in DD.MM.YYYY format, return it
      if (typeof date === "string" && date.match(/^\d{1,2}\.\d{2}\.\d{4}$/)) {
        return date;
      }

      // If it's not a Date object, try to convert it
      if (!(date instanceof Date)) {
        date = new Date(date);
      }

      let day, month, year;
      day = date.getDate();
      month = ("0" + (date.getMonth() + 1)).slice(-2);
      year = date.getFullYear();

      return `${day}.${month}.${year}`;
    };

    const updateSort = () => {
      isSearch.value = true;
      isSearch.value = false;
    };

    const search = () => {
      isSearch.value = true;
      selectPage(1);
    };

    const resetFilters = () => {
      searchValue.value = {};
      searchValue1.value = {};
      serverOptions.value.sortBy = "";
    };

    const moveItemsToRight = () => {
      if (itemsSelected.value.length === 0) {
        return;
      }

      if (!items.value.left || items.value.left.length === 0) {
        return;
      }

      itemsSelected.value.filter(isValidLeftRow).forEach((element) => {
        if (!isProductSelected(element.pk)) {
          selectedProducts.value.push(element);
        }
        // Dodaj element do prawej tabeli
        items.value.right.push(element);
      });
      syncMontageProductPks();

      itemsSelected.value = [];
      leftSelectedPks.value = [];

      // Odśwież obie tabele
      getMontageProducts(false);
      getMontageProducts(true);
    };

    const moveItemsToLeft = () => {
      itemsRightSelected.value.filter(isValidLeftRow).forEach((element) => {
        const pk = Number(element.pk);
        selectedProducts.value = selectedProducts.value.filter(
          (row) => Number(row.pk) !== pk
        );
      });
      syncMontageProductPks();
      itemsRightSelected.value = [];

      // Refresh both tables
      getMontageProducts(false);
      getMontageProducts(true);
    };

    const saveEdit = () => {
      if (!canChangeMontage.value) {
        return;
      }
      sentForm.value = true;

      // Only format the date if it exists
      if (montageObj.value.forced_deadline_date) {
        montageObj.value.forced_deadline_date = format(
          montageObj.value.forced_deadline_date
        );
      }

      if (
        montageObj.value.paper_option &&
        montageObj.value.sheet_format &&
        montageObj.value.rw_paper
      ) {
        // v-model now stores pk directly, so no conversion needed
        const montageData = {
          ...montageObj.value,
          rw_status:
            montageObj.value.rw_status?.value || montageObj.value.rw_status,
          price: totalMontageCost.value.toFixed(2),
        };

        store.dispatch("updateMontage", montageData);
      }
    };

    const getFilters = (val) => {
      store.dispatch("getMontageFilterGroup", { type: val });
      store.dispatch("getMontageFormatsOptions", { type: val });
      store.dispatch("getMontageQuantities", { type: val });
      store.dispatch("getMontagePaperOptions", { type: val });
    };

    const getOrderProductFiles = (pk, type) => {
      if (pk) {
        store.dispatch("getOrderProductFiles", {
          pk: pk,
          type: type,
        });
      }
    };

    const getAdminCard = (pk) => {
      if (pk) {
        store.dispatch("getOrderAdminCard", pk);
      }
    };

    const edit = (item) => {
      mActions.value = true;
      editObj.value = item;
    };

    const updateMontageProduct = () => {
      store.dispatch("updateMontageProduct", editObj.value);
    };

    const preview = (item) => {
      previewData.value = { ...item, preview: null };
      store.dispatch("getOrderProductsFile", { pk: item.pk });
    };

    const openPreviewWithData = (data) => {
      if (!data?.product_file) return;
      previewData.value = {
        ...(previewData.value || {}),
        preview: data,
      };
      nextTick(() => {
        mPreview.value = true;
      });
    };

    const startProcess = (pk) => {
      if (!canChangeCurrentStatus()) {
        return;
      }
      let payload = {
        pk: pk,
        type: "/start_process/",
      };

      store.dispatch("startMontageProcess", payload);
    };

    const endProcess = (pk, val, process) => {
      if (!canSetStatus(process || currentProcess())) {
        return;
      }
      let payload = {
        pk: pk,
        type: "/admin_state_update/",
      };

      if (!process) {
        payload[currentProcess()] = val;
        lastProcess.value.type = currentProcess();
        lastProcess.value.val = val;
      } else {
        payload[process] = val;
        lastProcess.value.type = process;
        lastProcess.value.val = val;
      }
      store.dispatch("startMontageProcess", payload);
    };

    const showProcessBox = (process) => {
      if (process === "closed") {
        if (realizationMontage.value.mounted) {
          return false;
        } else {
          return true;
        }
      } else if (process === "mounted") {
        if (
          realizationMontage.value.radiated &&
          realizationMontage.value.printed
        ) {
          return false;
        } else {
          return true;
        }
      } else if (process === "radiated") {
        if (
          !realizationMontage.value.closed &&
          !realizationMontage.value.mounted
        ) {
          return false;
        } else {
          return true;
        }
      } else if (process === "printed") {
        if (
          !realizationMontage.value.radiated &&
          !realizationMontage.value.mounted
        ) {
          return false;
        } else {
          return true;
        }
      }
    };

    // Each realization status has a permission of its own; starting and
    // finishing work needs the permission of the current stage - the same
    // rules as MontageRealizationController in the old panel.
    const montageStatusPermissions = {
      closed: montagePermissionsConst.set_closed_montage_permission,
      mounted: montagePermissionsConst.set_mounted_montage_permission,
      radiated: montagePermissionsConst.set_radiated_montage_permission,
      printed: montagePermissionsConst.set_printed_montage_permission,
    };
    const canSetStatus = (status) =>
      Boolean(montageStatusPermissions[status]) &&
      hasPermission(montageStatusPermissions[status]);
    const canChangeCurrentStatus = () => {
      // A printed montage has no further stage to work on.
      if (realizationMontage.value?.printed) {
        return false;
      }
      return canSetStatus(currentProcess());
    };

    const currentProcess = () => {
      let process;
      if (realizationMontage.value.mounted) {
        if (realizationMontage.value.radiated) {
          process = "printed";
        } else if (!realizationMontage.value.printed) {
          process = "radiated";
        }
      } else if (!realizationMontage.value.closed) {
        process = "closed";
      } else {
        process = "mounted";
      }

      return process;
    };

    const changeStatus = () => {
      store.dispatch("getMontage", { pk: route.params?.pk });
      processBox.value = true;
    };

    const montagePk = computed(() => route.params?.pk);
    const {
      canDuplicateMontage,
      duplicateConfirmPk,
      duplicateConfirmContent,
      isDuplicating,
      askDuplicateMontage,
      duplicateMontage,
    } = useMontageDuplicate();

    const getChosenOptinos = (pk) => {
      if (!pk || chosenOptionsCache.value[pk] || chosenOptionsLoadingPk.value) {
        return;
      }
      chosenOptionsLoadingPk.value = pk;
      store.dispatch("getAdminChsenOptions", pk);
    };

    const showChosenOptions = (pk) => {
      activeChosenPk.value = pk;
      getChosenOptinos(pk);
    };

    const hideChosenOptions = () => {
      activeChosenPk.value = null;
    };

    const getChosenOptionsForPk = (pk) => chosenOptionsCache.value[pk];
    const getChosenOptionsRows = (pk) =>
      getChosenOptionsForPk(pk)?.chosen_options || [];
    const chosenRows = (item) => getChosenOptionsRows(item?.pk);
    const isChosenOptionsVisible = (pk) =>
      activeChosenPk.value === pk && !!getChosenOptionsForPk(pk);
    const isChosenOptionsLoading = (pk) =>
      activeChosenPk.value === pk && chosenOptionsLoadingPk.value === pk;
    const loadingOptionsText = "Ładowanie opcji...";
    const actionsToggleClass = "btn btn-default btn-xs actions-toggle";
    const getPreflightFilePk = (item) =>
      item?.product_file?.preflight_status?.file_pk;

    // The client and result file buttons stay visible and go grey when there is nothing to
    // download, the cover ones are hidden instead - same as in the admin panel.
    const isClientFileNotAvailable = (item) =>
      !item?.product_file?.client_file_url;
    const isResultFileNotAvailable = (item) =>
      !item?.product_file?.preflight_result;
    const isClientCoverFileNotAvailable = (item) =>
      !item?.product_file?.client_cover_file_url;
    const isCoverResultFileNotAvailable = (item) =>
      !item?.product_file?.cover_preflight_result;
    const formatSummaryValue = (value) => Number(value || 0).toFixed(2);
    const getLeftRowClass = (item) => [
      bodyRowClassNameFunction(item),
      { "summary-row": item?.isSummary },
    ];

    const scrollToPreview = () => {
      const prvElement = document.getElementById("prv");
      if (prvElement) {
        prvElement.scrollIntoView({ behavior: "smooth" });
      }
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const updateRowsPerPage = (side, value) => {
      const parsedValue = Number.parseInt(value, 10);
      const safeValue =
        Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : 25;

      if (side === "right") {
        if (serverOptionsRight.value.rowsPerPage !== safeValue) {
          serverOptionsRight.value.rowsPerPage = safeValue;
        }
        serverOptionsRight.value.page = 1;
        return;
      }

      if (serverOptions.value.rowsPerPage !== safeValue) {
        serverOptions.value.rowsPerPage = safeValue;
      }
      serverOptions.value.page = 1;
    };

    // Parser akceptujący różne formaty dat (Date | 'dd.mm.yyyy' | 'yyyy-mm-dd')
    const parseDateFlexible = (val) => {
      if (!val) return null;
      if (val instanceof Date) {
        if (isNaN(val.getTime())) return null;
        return new Date(val.getFullYear(), val.getMonth(), val.getDate());
      }
      if (typeof val === "number") {
        const d = new Date(val);
        if (isNaN(d.getTime())) return null;
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
      }
      if (typeof val === "string") {
        const trimmed = val.trim();
        // dd.mm.yyyy
        const dotMatch = trimmed.match(/^([0-3]?\d)\.([0-1]?\d)\.(\d{4})/);
        if (dotMatch) {
          const day = parseInt(dotMatch[1], 10);
          const month = parseInt(dotMatch[2], 10) - 1;
          const year = parseInt(dotMatch[3], 10);
          const d = new Date(year, month, day);
          return isNaN(d.getTime()) ? null : d;
        }
        // yyyy-mm-dd (lub z czasem)
        const hyphenMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (hyphenMatch) {
          const year = parseInt(hyphenMatch[1], 10);
          const month = parseInt(hyphenMatch[2], 10) - 1;
          const day = parseInt(hyphenMatch[3], 10);
          const d = new Date(year, month, day);
          return isNaN(d.getTime()) ? null : d;
        }
        // Fallback natywny
        const d = new Date(trimmed);
        if (isNaN(d.getTime())) return null;
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
      }
      return null;
    };

    getFilters("left");
    getFilters("right");
    store.dispatch("getSites");
    store.dispatch("getMontagePapers");
    store.dispatch("getMontageFormats");
    store.dispatch("getMontagePlates");

    if (route.params?.pk) {
      store.dispatch("getMontage", { pk: route.params?.pk });
    }

    // Pobierz dane dla prawej tabeli na początku
    getMontageProducts(true);

    // Pobierz filtry dla prawej tabeli niezależnie od produktów w montażu
    store.dispatch("getMontageFilterGroup", { type: "right" });
    store.dispatch("getMontageFormatsOptions", { type: "right" });
    store.dispatch("getMontageQuantities", { type: "right" });
    store.dispatch("getMontagePaperOptions", { type: "right" });

    onMounted(() => {
      if (localStorage.getItem("montagesESearchValue") !== null) {
        searchValue.value = localStorage.getItem("montagesESearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      if (localStorage.getItem("montagesESearchValue1") !== null) {
        searchValue1.value = localStorage.getItem("montagesESearchValue1");
        searchValue1.value = JSON.parse(searchValue1.value);
      }
    });

    watch(
      () => searchValue.value,
      function () {
        setTimeout(() => {
          localStorage.setItem(
            "montagesESearchValue",
            JSON.stringify(searchValue.value)
          );
          getMontageProducts(false);
        }, 1000);
      },
      { deep: true }
    );

    watch(
      () => searchValue1.value,
      function () {
        setTimeout(() => {
          localStorage.setItem(
            "montagesESearchValue1",
            JSON.stringify(searchValue1.value)
          );
          getMontageProducts(true);
        }, 1000);
      },
      { deep: true }
    );

    watch(
      () => chosenOptionsData.value,
      function (newValue) {
        if (newValue?.status === 200 && activeChosenPk.value) {
          chosenOptionsCache.value[activeChosenPk.value] = newValue.data;
        }
        chosenOptionsLoadingPk.value = null;
      }
    );

    watch(
      () => orderProductsFileData.value,
      function (newValue) {
        openPreviewWithData(newValue?.data);
      }
    );

    watch(
      () => montageData.value,
      function (newValue) {
        if (newValue.data) {
          // Copy backend data but preserve existing Multiselect objects
          const backendData = { ...newValue.data };
          // Use Object.assign to preserve reactivity instead of direct assignment
          Object.assign(montageObj.value, backendData);
          Object.assign(realizationMontage.value, backendData);

          // The API returns the montage products as full rows - keep them for
          // the summary and hand only their pks back to the API.
          selectedProducts.value = Array.isArray(backendData.montage_products)
            ? backendData.montage_products.filter(isValidLeftRow)
            : [];
          syncMontageProductPks();

          // Store IDs temporarily - will be set when options load
          if (backendData.paper_option) {
            const paperId =
              typeof backendData.paper_option === "object"
                ? backendData.paper_option.pk
                : backendData.paper_option;

            if (papersOpt.value && papersOpt.value.length > 0) {
              montageObj.value.paper_option = paperId;
            } else {
              montageObj.value._temp_paper_option_id = paperId;
            }
          }

          if (backendData.sheet_format) {
            const formatId =
              typeof backendData.sheet_format === "object"
                ? backendData.sheet_format.pk
                : backendData.sheet_format;

            if (formatsOpt.value && formatsOpt.value.length > 0) {
              montageObj.value.sheet_format = formatId;
            } else {
              montageObj.value._temp_sheet_format_id = formatId;
            }
          }

          if (backendData.plate) {
            const plateId =
              typeof backendData.plate === "object"
                ? backendData.plate.readable_plate
                : backendData.plate;

            if (platesOpt.value && platesOpt.value.length > 0) {
              montageObj.value.plate = plateId;
            } else {
              montageObj.value._temp_plate_id = plateId;
            }
          }

          // Force Vue to update the DOM
          nextTick(() => {
            // DOM should be updated now
          });

          if (backendData.rw_paper) {
            const rwPaperId =
              typeof backendData.rw_paper === "object"
                ? backendData.rw_paper.pk
                : backendData.rw_paper;

            // Check if papersOpt is already loaded
            if (papersOpt.value && papersOpt.value.length > 0) {
              montageObj.value.rw_paper = rwPaperId;
            } else {
              // papersOpt not ready yet, store temporarily
              montageObj.value._temp_rw_paper_id = rwPaperId;
            }
          }

          // Convert forced_deadline_date from backend string to Date object
          if (backendData.forced_deadline_date) {
            montageObj.value.forced_deadline_date = parseDateFlexible(
              backendData.forced_deadline_date
            );
          }

          if (processBox.value) {
            mActions1.value = true;
          }
        }
        getMontageProducts(true);
        getMontageProducts(false);
      }
    );

    watch(
      () => updateMontageProductData.value,
      function (newValue) {
        if (newValue.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zlecenia zostały zaktualizowane!",
          });
          getMontageProducts();
          mActions.value = false;
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => updateMontageData.value,
      function (newValue) {
        if (newValue.status === 200) {
          router
            .push({
              name: "MontagesList",
              path: "/montages/list",
            })
            .then(() => {
              store.dispatch("showToaster", {
                type: "success",
                content: "Dane montażu zostały zaktualizowane",
              });
            });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => montageProductsData.value,
      function (newValue) {
        if (newValue.right) {
          itemsAll.value.right = newValue.data.count;
          items.value.right = [];
          const pageOffset =
            (Number(serverOptionsRight.value.page || 1) - 1) *
            Number(serverOptionsRight.value.rowsPerPage || 25);
          newValue.data.results?.forEach((element, index) => {
            items.value.right.push({
              ...element,
              lp: pageOffset + index + 1,
            });
          });

          // Pobierz opcje filtrów dla prawej tabeli
          const productPks = montageObj.value.montage_products
            .map((product) => {
              // Jeśli product to już liczba (pk), zwróć ją
              if (typeof product === "number") {
                return product;
              }
              // Jeśli product to obiekt, zwróć jego pk
              if (product && typeof product === "object" && product.pk) {
                return product.pk;
              }
              // Jeśli product to string, spróbuj sparsować jako liczbę
              if (typeof product === "string" && !isNaN(product)) {
                return parseInt(product, 10);
              }
              // W przeciwnym razie zwróć null (zostanie odfiltrowane)
              return null;
            })
            .filter((pk) => pk !== null);
          store.dispatch("getMontageFilterGroup", {
            type: "right",
            pks: productPks,
          });
          store.dispatch("getMontageFormatsOptions", {
            type: "right",
            pks: productPks,
          });
          store.dispatch("getMontageQuantities", {
            type: "right",
            pks: productPks,
          });
          store.dispatch("getMontagePaperOptions", {
            type: "right",
            pks: productPks,
          });

          // Wiersz podsumowania dla prawej tabeli
          if (items.value.right.length > 0) {
            const summary = items.value.right.reduce(
              (acc, item) => {
                const rawQty = String(
                  item.selected_quantity__quantity ??
                    item.selected_quantity ??
                    item.quantity ??
                    0
                );
                const leadingMatch = rawQty.match(/^\s*(\d+)/);
                const qtyParsed = leadingMatch ? parseInt(leadingMatch[1]) : 0;
                acc.selected_quantity__quantity += qtyParsed;
                acc.net_price += Number(item.net_price_pln) || 0;
                acc.weight += Number(item.weight) || 0;
                return acc;
              },
              { selected_quantity__quantity: 0, net_price: 0, weight: 0 }
            );
            items.value.right.push({
              isSummary: true,
              lp: "",
              product_name: "",
              selected_quantity__quantity: Math.round(
                summary.selected_quantity__quantity
              ),
              selected_quantity: Math.round(
                summary.selected_quantity__quantity
              ),
              net_price: Math.round(summary.net_price * 100) / 100,
              weight: Math.round(summary.weight * 100) / 100,
            });
          }
          loading1.value = false;
        } else {
          itemsAll.value.left = newValue.data.count;
          items.value.left = [];
          const pageOffset =
            (Number(serverOptions.value.page || 1) - 1) *
            Number(serverOptions.value.rowsPerPage || 25);
          newValue.data.results?.forEach((element, index) => {
            items.value.left.push({
              ...element,
              lp: pageOffset + index + 1,
            });
          });
          // Wiersz podsumowania dla lewej tabeli
          if (items.value.left.length > 0) {
            const summary = items.value.left.reduce(
              (acc, item) => {
                const rawQty = String(
                  item.selected_quantity__quantity ??
                    item.selected_quantity ??
                    item.quantity ??
                    0
                );
                const leadingMatch = rawQty.match(/^\s*(\d+)/);
                const qtyParsed = leadingMatch ? parseInt(leadingMatch[1]) : 0;
                acc.selected_quantity__quantity += qtyParsed;
                acc.net_price += Number(item.net_price_pln) || 0;
                acc.weight += Number(item.weight) || 0;
                return acc;
              },
              { selected_quantity__quantity: 0, net_price: 0, weight: 0 }
            );
            items.value.left.push({
              isSummary: true,
              lp: "",
              product_name: "",
              selected_quantity__quantity: Math.round(
                summary.selected_quantity__quantity
              ),
              selected_quantity: Math.round(
                summary.selected_quantity__quantity
              ),
              net_price: Math.round(summary.net_price * 100) / 100,
              weight: Math.round(summary.weight * 100) / 100,
            });
          }
          loading.value = false;
        }
      }
    );

    watch(
      () => sitesData.value,
      function (newValue) {
        if (
          newValue.data &&
          newValue.data.results &&
          Array.isArray(newValue.data.results)
        ) {
          sites.value = newValue.data.results.map((element) => ({
            name: element.name,
            value: element.pk,
          }));

          if (!siteFilterInitialized.value) {
            siteFilterInitialized.value = true;
            getMontageProducts();
          }
        }
      }
    );

    watch(
      () => platesData.value,
      function (newValue) {
        if (newValue.data && Array.isArray(newValue.data)) {
          // Clear existing options before adding new ones
          platesOpt.value = [];
          newValue.data.forEach((element) => {
            platesOpt.value.push({
              name: element.readable_plate,
              value: element.readable_plate,
            });
          });

          // Set plate from temp ID if it was stored
          if (montageObj.value._temp_plate_id) {
            montageObj.value.plate = montageObj.value._temp_plate_id;
            delete montageObj.value._temp_plate_id;
          }
          // plate stays as string (readable_plate), no conversion needed
        }
      }
    );

    watch(
      () => papersData.value,
      function (newValue) {
        if (newValue.data && Array.isArray(newValue.data)) {
          // Clear existing options before adding new ones
          papersOpt.value = [];
          newValue.data.forEach((element) => {
            papersOpt.value.push({
              name:
                "[" +
                element.group_pk +
                "] " +
                element.group_name +
                " [" +
                element.pk +
                "] " +
                element.label,
              value: element.pk,
            });
          });

          // Set paper_option from temp ID if it was stored
          if (montageObj.value._temp_paper_option_id) {
            montageObj.value.paper_option =
              montageObj.value._temp_paper_option_id;
            delete montageObj.value._temp_paper_option_id;
          } else if (
            montageObj.value &&
            montageObj.value.paper_option &&
            typeof montageObj.value.paper_option === "object"
          ) {
            // If it's an object, extract just the pk
            montageObj.value.paper_option = montageObj.value.paper_option.pk;
          }

          // Set rw_paper from temp ID if it was stored
          if (montageObj.value._temp_rw_paper_id) {
            montageObj.value.rw_paper = montageObj.value._temp_rw_paper_id;
            delete montageObj.value._temp_rw_paper_id;
            delete montageObj.value._temp_rw_paper_obj;
          } else if (
            montageObj.value &&
            montageObj.value.rw_paper &&
            typeof montageObj.value.rw_paper === "object"
          ) {
            // If it's an object, extract just the pk
            montageObj.value.rw_paper = montageObj.value.rw_paper.pk;
          }
        }
      }
    );

    watch(
      () => formatsData.value,
      function (newValue) {
        if (newValue.data && Array.isArray(newValue.data)) {
          // Clear existing options before adding new ones
          formatsOpt.value = [];
          let group;
          newValue.data.forEach((element) => {
            if (element.group_pk && element.group_name) {
              group = "[" + element.group_pk + "] " + element.group_name;
            } else {
              group = "";
            }

            formatsOpt.value.push({
              name: group + " [" + element.pk + "] " + element.readable_format,
              value: element.pk,
            });
          });

          // Set sheet_format from temp ID if it was stored
          if (montageObj.value._temp_sheet_format_id) {
            montageObj.value.sheet_format =
              montageObj.value._temp_sheet_format_id;
            delete montageObj.value._temp_sheet_format_id;
          } else if (
            montageObj.value &&
            montageObj.value.sheet_format &&
            typeof montageObj.value.sheet_format === "object"
          ) {
            // If it's an object, extract just the pk
            montageObj.value.sheet_format = montageObj.value.sheet_format.pk;
          }
        }
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          loading.value = true;
          getMontageProducts(false);
        }
      },
      { deep: true }
    );

    watch(
      () => serverOptionsRight.value,
      function () {
        if (!isSearch.value) {
          loading1.value = true;
          getMontageProducts(true);
        }
      },
      { deep: true }
    );

    watch(
      () => filtersLeft.value,
      function () {
        loading.value = true;
        getMontageProducts();
      },
      { deep: true }
    );

    watch(
      () => filterSite.value,
      function () {
        loading.value = true;
        getMontageProducts();
      }
    );

    watch(
      () => items.value.left,
      function () {
        const available = new Set(allLeftSelectablePks.value);
        leftSelectedPks.value = leftSelectedPks.value.filter((pk) =>
          available.has(pk)
        );
        syncLeftSelectedRows();
      },
      { deep: false }
    );

    watch(
      () => montageProcessData.value,
      function (newValue) {
        if (newValue.data === "started") {
          store.dispatch("getMontage", { pk: realizationMontage.value.pk });
        } else {
          if (newValue.status === 200) {
            let responseText;
            if (lastProcess.value.type === "closed") {
              if (lastProcess.value.val) {
                responseText = "Montaż został zamknięty!";
              } else {
                responseText = "Montaż został otwarty!";
              }
            }
            if (lastProcess.value.type === "mounted") {
              if (lastProcess.value.val) {
                responseText = "Montaż został zmontowany!";
              } else {
                responseText = "Montowanie montażu zostało cofnięte!";
              }
            }
            if (lastProcess.value.type === "radiated") {
              if (lastProcess.value.val) {
                responseText = "Montaż został naświetlony!";
              } else {
                responseText = "Naświetlenie montażu zostało cofnięte!";
              }
            }
            if (lastProcess.value.type === "printed") {
              if (lastProcess.value.val) {
                responseText = "Montaż został wydrukowany!";
              } else {
                responseText = "Wydrukowanie montażu zostało cofnięte!";
              }
            }
            mActions1.value = false;
            store.dispatch("showToaster", {
              type: "success",
              content: responseText,
            });
          } else {
            var msg = [];
            for (const [key, value] of Object.entries(newValue.data)) {
              msg.push(key + ": " + value);
            }
            store.dispatch("showToaster", {
              type: "error",
              content: msg[0],
            });
          }
        }
      }
    );

    // Funkcje do obsługi menu akcji
    const showActionsMenu = (itemId) => {
      activeActionsMenu.value = itemId;
    };

    const hideActionsMenu = () => {
      activeActionsMenu.value = null;
    };

    // Summary helpers - counted over the whole montage, not just the page the
    // right table currently holds.
    const getUniqueOrdersCount = () => {
      const uniqueOrders = new Set(
        selectedProducts.value
          .filter((row) => row?.order_pk)
          .map((item) => item.order_pk)
      );
      return uniqueOrders.size;
    };

    // net_price is in the order currency, so the value of the whole montage is
    // summed from net_price_pln and always shown in PLN.
    const getMontageProductsPrice = () =>
      selectedProducts.value.reduce(
        (total, item) => total + (Number(item.net_price_pln) || 0),
        0
      );

    // Computed property dla sformatowanego terminu
    const formattedDeadline = computed(() => {
      return getRealizationDate(montageObj.value, selectedProducts.value);
    });

    // Number of order products added to the montage
    const nonSummaryRightCount = computed(() => selectedProducts.value.length);

    // Helper function to get number value safely
    const getNumber = (value) => {
      return Number(value) || 0;
    };

    // Some montage option endpoints return a plain array in `.data`, others
    // (paginated or error) responses don't - guard before calling `.find`.
    const findInResponseData = (response, predicate) =>
      Array.isArray(response?.data) ? response.data.find(predicate) : undefined;

    // Function to calculate montage price based on AngularJS logic. A missing
    // paper, sheet format or plate contributes 0 to its own term instead of
    // short-circuiting the whole formula - like montageSrvc in the old panel.
    const getMontagePrice = (montageData, paperOption, sheetFormat, plate) => {
      const plateSizeX = plate ? plate.size_x : 0;
      const plateSizeY = plate ? plate.size_y : 0;
      const plateUnitPrice = plate ? plate.price : 0;
      const sheetSizeX = sheetFormat ? sheetFormat.size_x : 0;
      const sheetSizeY = sheetFormat ? sheetFormat.size_y : 0;
      const paperOptionWeight = paperOption ? paperOption.weight : 0;
      const paperOptionPrice = paperOption ? paperOption.paper_price : 0;

      const calculatedPlatePrice =
        (((getNumber(plateSizeX) / 1000) * getNumber(plateSizeY)) / 1000) *
        getNumber(plateUnitPrice);

      const montageBrutto =
        getNumber(montageData.quantity_net) +
        getNumber(montageData.quantity_surplus);

      const calculatedPaperPrice =
        (((((getNumber(sheetSizeX) / 1000) * getNumber(sheetSizeY)) / 1000) *
          getNumber(paperOptionWeight)) /
          1000) *
        getNumber(paperOptionPrice);

      const calculatedPlateQuantity = getNumber(montageData.plate_quantity);

      const calculatedMontageExtraNet = getNumber(montageData.extra_net);

      return (
        montageBrutto * calculatedPaperPrice +
        calculatedPlateQuantity * calculatedPlatePrice +
        calculatedMontageExtraNet
      );
    };

    // Suma kosztu montażu i wartości dodatkowej
    const totalMontageCost = computed(() => {
      // v-model now stores pk, need to find full objects from data arrays
      const paperOption = findInResponseData(
        papersData.value,
        (p) => p.pk === montageObj.value?.paper_option
      );
      const sheetFormat = findInResponseData(
        formatsData.value,
        (f) => f.pk === montageObj.value?.sheet_format
      );
      const plate = findInResponseData(
        platesData.value,
        (p) => p.readable_plate === montageObj.value?.plate
      );

      return getMontagePrice(montageObj.value, paperOption, sheetFormat, plate);
    });

    // Funkcja obliczająca termin realizacji zgodnie ze starym systemem
    const getRealizationDate = (montageData, products) => {
      let montageDeadline, minProductDate, minDate;

      if (montageData.forced_deadline_date) {
        montageDeadline = parseDateFlexible(montageData.forced_deadline_date);
      } else {
        montageDeadline = undefined;
      }

      if (products && products.length) {
        const productDates = products
          .filter((p) => p && !p.isSummary)
          .map((p) =>
            parseDateFlexible(
              p.order_realization_date || p.order__realization_date
            )
          )
          .filter((d) => d instanceof Date && !isNaN(d.getTime()));
        if (productDates.length) {
          minProductDate = productDates.reduce(
            (min, d) => (!min || d < min ? d : min),
            null
          );
        } else {
          minProductDate = undefined;
        }
      } else {
        minProductDate = undefined;
      }

      if (montageDeadline && minProductDate) {
        minDate =
          montageDeadline < minProductDate ? montageDeadline : minProductDate;
      } else if (montageDeadline) {
        minDate = montageDeadline;
      } else if (minProductDate) {
        minDate = minProductDate;
      } else {
        return "Nie ustawiono";
      }

      // Sprawdź czy minDate jest obiektem Date przed formatowaniem
      if (minDate instanceof Date && !isNaN(minDate.getTime())) {
        return format(minDate);
      } else if (minDate) {
        const convertedDate = parseDateFlexible(minDate);
        if (!isNaN(convertedDate.getTime())) {
          return format(convertedDate);
        }
      }
      return "Nie ustawiono";
    };

    // Watchery dla danych filtrów
    watch(
      () => paperOptionsData.value,
      function (newValue) {
        if (newValue.data && Array.isArray(newValue.data)) {
          // Wyczyść filtry przed dodaniem nowych
          papers.value[newValue.type] = [];
          newValue.data.forEach((element) => {
            papers.value[newValue.type].push({
              name:
                "[" +
                element.site_name +
                "] " +
                "[" +
                element.group_pk +
                "] " +
                element.group_name +
                " [" +
                element.pk +
                "] " +
                element.label,
              value: element.pk,
            });
          });
        }
      }
    );

    watch(
      () => quantityData.value,
      function (newValue) {
        if (newValue.data && Array.isArray(newValue.data)) {
          // Wyczyść filtry przed dodaniem nowych
          quantities.value[newValue.type] = [];
          newValue.data.forEach((element) => {
            quantities.value[newValue.type].push({
              name:
                "[" +
                element.site_name +
                "] " +
                "[" +
                element.pk +
                "] " +
                element.display_quantity,
              value: element.pk,
            });
          });
        }
      }
    );

    watch(
      () => formatData.value,
      function (newValue) {
        if (newValue.data && Array.isArray(newValue.data)) {
          // Wyczyść filtry przed dodaniem nowych
          formats.value[newValue.type] = [];
          let group;
          newValue.data.forEach((element) => {
            if (element.group_pk && element.group_name) {
              group = "[" + element.group_pk + "] " + element.group_name;
            } else {
              group = "";
            }

            formats.value[newValue.type].push({
              name:
                "[" +
                element.site_name +
                "] " +
                group +
                " [" +
                element.pk +
                "] " +
                element.readable_format,
              value: element.pk,
            });
          });
        }
      }
    );

    watch(
      () => montageFilterGroupData.value,
      function (newValue) {
        if (newValue.data) {
          // Znormalizuj odpowiedź do tablicy
          const groups = Array.isArray(newValue.data?.results)
            ? newValue.data.results
            : Array.isArray(newValue.data)
            ? newValue.data
            : [];

          if (groups.length === 0) {
            return;
          }

          // Wyczyść filtry dla danego typu przed dodaniem nowych
          montageFilters.value[newValue.type] = [];
          let productOptions = [];
          groups.forEach((element) => {
            productOptions = [];
            if (Array.isArray(element.product_options)) {
              element.product_options.forEach((option) => {
                productOptions.push({
                  name:
                    "[" +
                    option.group_pk +
                    "] " +
                    option.group_name +
                    " [" +
                    option.pk +
                    "] " +
                    option.label,
                  value: option.pk,
                });
              });
            }
            montageFilters.value[newValue.type].push({
              name: element.name,
              site_name: element.site_name,
              filterId: "filter" + element.pk,
              product_options: productOptions,
            });
          });
        }
      }
    );

    // Watcher dla filtrów prawej tabeli
    watch(
      () => filtersRight.value,
      function () {
        loading1.value = true;
        getMontageProducts(true);
      },
      { deep: true }
    );

    // Watchers for montageObj fields to trigger summary box updates
    watch(
      () => montageObj.value.quantity_net,
      function () {}
    );

    watch(
      () => montageObj.value.quantity_surplus,
      function () {}
    );

    watch(
      () => montageObj.value.plate_quantity,
      function () {}
    );

    watch(
      () => montageObj.value.extra_net,
      function () {}
    );

    watch(
      () => montageObj.value.paper_option,
      function () {},
      { deep: true }
    );

    watch(
      () => montageObj.value.sheet_format,
      function () {},
      { deep: true }
    );

    watch(
      () => montageObj.value.plate,
      function () {},
      { deep: true }
    );

    return {
      canChangeMontage,
      canDuplicateMontage,
      duplicateConfirmPk,
      duplicateConfirmContent,
      isDuplicating,
      montagePk,
      askDuplicateMontage,
      duplicateMontage,
      canSetStatus,
      canChangeCurrentStatus,
      canDisplayMontagesSites,
      errorsAdminData,
      montageObj,
      format,
      headers,
      itemsAll,
      items,
      loading,
      loading1,
      isSearch,
      resetFilters,
      search,
      searchValue,
      searchValue1,
      serverOptions,
      serverOptionsRight,
      updateRowsPerPage,
      updateSort,
      itemsSelected,
      itemsRightSelected,
      filtersLeft,
      filtersRight,
      montageFilters,
      sites,
      filterSite,
      formats,
      quantities,
      papers,
      papersOpt,
      formatsOpt,
      platesOpt,
      moveItemsToRight,
      moveItemsToLeft,
      filterRWOptions,
      filterStatusses,
      filterSourceOptions,
      saveEdit,
      getOrderProductFiles,
      getAdminCard,
      mActions,
      mActions1,
      mPreview,
      edit,
      editObj,
      updateMontageProduct,
      sentForm,
      preview,
      previewData,
      realizationMontage,
      startProcess,
      showProcessBox,
      endProcess,
      currentProcess,
      changeStatus,
      getChosenOptinos,
      showChosenOptions,
      hideChosenOptions,
      getChosenOptionsForPk,
      getChosenOptionsRows,
      chosenRows,
      isChosenOptionsVisible,
      isChosenOptionsLoading,
      loadingOptionsText,
      actionsToggleClass,
      getPreflightFilePk,
      isClientFileNotAvailable,
      isResultFileNotAvailable,
      isClientCoverFileNotAvailable,
      isCoverResultFileNotAvailable,
      formatSummaryValue,
      getLeftRowClass,
      isValidLeftRow,
      isLeftRowSelected,
      toggleLeftRowSelection,
      toggleSelectAllLeft,
      isAllLeftSelected,
      toggleLeftSort,
      isLeftSortedHeader,
      isLeftSortInactive,
      inactiveLeftSortClass,
      leftSortIconClass,
      leftHeaderClass,
      activeChosenPk,
      chosenOptionsLoadingPk,
      chosenOptionsData,
      bodyRowClassNameFunction,
      scrollToPreview,
      activeActionsMenu,
      showActionsMenu,
      hideActionsMenu,
      getUniqueOrdersCount,
      getMontageProductsPrice,
      formattedDeadline,
      nonSummaryRightCount,
      totalMontageCost,
    };
  },
  computed: {
    summaryItemsLeft() {
      if (!this.items.left || this.items.left.length === 0) {
        return { selected_quantity__quantity: 0, net_price: 0, weight: 0 };
      }
      const pageItems = this.items.left.filter((row) => !row.isSummary);
      const summary = pageItems.reduce(
        (acc, item) => {
          const rawQty = String(
            item.selected_quantity__quantity ?? item.selected_quantity ?? ""
          );
          const leadingMatch = rawQty.match(/^\s*(\d+)/);
          const parsedQty = leadingMatch ? parseInt(leadingMatch[1]) : 0;
          acc.selected_quantity__quantity += parsedQty;
          acc.net_price += Number(item.net_price) || 0;
          acc.weight += Number(item.weight) || 0;
          return acc;
        },
        { selected_quantity__quantity: 0, net_price: 0, weight: 0 }
      );
      return {
        selected_quantity__quantity: Math.round(
          summary.selected_quantity__quantity
        ),
        net_price: Math.round(summary.net_price * 100) / 100,
        weight: Math.round(summary.weight * 100) / 100,
      };
    },

    summaryItemsRight() {
      if (!this.items.right || this.items.right.length === 0) {
        return { selected_quantity__quantity: 0, net_price: 0, weight: 0 };
      }
      const pageItems = this.items.right.filter((row) => !row.isSummary);
      const summary = pageItems.reduce(
        (acc, item) => {
          const rawQty = String(
            item.selected_quantity__quantity ?? item.selected_quantity ?? ""
          );
          const leadingMatch = rawQty.match(/^\s*(\d+)/);
          const parsedQty = leadingMatch ? parseInt(leadingMatch[1]) : 0;
          acc.selected_quantity__quantity += parsedQty;
          acc.net_price += Number(item.net_price) || 0;
          acc.weight += Number(item.weight) || 0;
          return acc;
        },
        { selected_quantity__quantity: 0, net_price: 0, weight: 0 }
      );
      return {
        selected_quantity__quantity: Math.round(
          summary.selected_quantity__quantity
        ),
        net_price: Math.round(summary.net_price * 100) / 100,
        weight: Math.round(summary.weight * 100) / 100,
      };
    },
  },
};
</script>

<style scoped>
.table-summary {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 15px;
  margin: 15px 0;
}

.table-summary .row {
  margin: 0;
}

.table-summary .col-md-3 {
  padding: 5px 15px;
  border-right: 1px solid #dee2e6;
}

.table-summary .col-md-3:last-child {
  border-right: none;
}

/* Style dla menu akcji */
.actions-dropdown {
  position: relative;
  display: inline-block;
}

.actions-toggle {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #6c757d;
}

.actions-toggle:hover {
  background: #e9ecef;
  color: #495057;
}

.actions-menu {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  padding: 5px 0;
}

.action-item {
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  border-radius: 0;
  margin: 0;
  padding: 8px 15px;
  background: white;
  color: #6c757d;
}

.action-item:hover {
  background: #f8f9fa;
  color: #495057;
}

.action-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.action-item:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

:deep(tr.montage-row--allegro td) {
  background-color: #99ffff !important;
}

:deep(tr.urgent td) {
  background-color: #ffbebe !important;
}

:deep(tr.waiting_for_payment td) {
  background-color: #ffebea !important;
}

:deep(tr.allegro td) {
  background-color: #99ffff !important;
}

:deep(tr.external td) {
  background-color: #f8ac59 !important;
}

/* Style dla wiersza podsumowania */
.summary-row {
  background-color: #f8f9fa !important;
  font-weight: bold;
  border-top: 2px solid #dee2e6;
}

.summary-row td {
  background-color: #f8f9fa !important;
  font-weight: bold;
}

.native-table-search {
  margin-top: 10px;
}

.native-header-cell {
  padding: 0 !important;
  min-width: 95px;
  vertical-align: top !important;
}

.native-header-content {
  position: relative;
  display: flex;
  flex-flow: column;
  padding: 10px 10px 40px;
  min-height: 58px;
}

.native-sort-button {
  position: relative;
  display: block;
  width: 100%;
  padding: 0 20px 0 0;
  border: 0;
  background: transparent;
  color: #373737;
  text-align: left;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.2;
}

.native-header-input {
  background: #f1f1f1;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 30px;
  padding: 0 5px;
  border: 0;
  border-top: 1px solid #e0e0e0;
}

.sort-icon {
  position: absolute;
  top: 0;
  right: 0;
}

.sort-icon--inactive {
  opacity: 0.35;
}

.select-column {
  width: 40px;
  text-align: center;
}

.col-lp {
  min-width: 55px;
  width: 55px;
}

.col-image {
  min-width: 90px;
  width: 90px;
}

.col-id,
.col-order,
.col-product-pk {
  min-width: 95px;
}

.col-qty,
.col-net,
.col-weight {
  min-width: 85px;
}

.col-currency {
  min-width: 70px;
  width: 70px;
}

.col-actions {
  min-width: 110px;
  width: 110px;
}
</style>
